import { Preferences } from "@capacitor/preferences";
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const Storage = localStorage;
export const set = (key, value) => {
    Storage.setItem(key, value);
};

export const get = (key) => {
    return Storage.getItem(key);
};

export const remove = (key) => {
    Storage.removeItem(key);
};

export const clear = () => {
    Storage.clear();
};

export const getDeviceId = async () => {
    const fpPromise = FingerprintJS.load();
    fpPromise
        .then(fp => fp.get())
        .then(result => {
            console.log(result.visitorId);
            Storage.setItem(KEYS.DEVICE_ID_KEY, result.visitorId);
            return result.visitorId;
        });
}

export const KEYS = {
  AUTH_OBJ: 'PHOTO_AUTH_OBJ',
  LOGIN_TOKEN: 'PHOTO_LOGIN_TOKEN',
  USERNAME: 'USERNAME',
  NETWORK_STATUS: 'NETWORK_STATUS',
  APP_VERSION: 'APP_VERSION',
  HOME_PAGE_SETTINGS: 'PHOTO_HOME_PAGE_SETTINGS',
  DB_INITIALIZED: 'DB_INITIALIZED',
  DEVICE_ID_KEY: "PHOTO_DEVICE_ID"
};
